export default [
  {
    id: '1',
    title: 'School grade 1',
    count: 80,
    image: require('./images/grade1.jpg'),
  }, 
  {
    id: '2',
    title: 'School grade 2',
    count: 160,
    image: require('./images/grade2.jpg'),
  }, 
  {
    id: '3',
    title: 'School grade 3',
    count: 200,
    image: require('./images/grade3.jpg'),
  }, 
  {
    id: '4',
    title: 'School grade 4',
    count: 200,
    image: require('./images/grade4.jpg'),
  }, 
  {
    id: '5',
    title: 'School grade 5',
    count: 185,
    image: require('./images/grade5.jpg'),
  }, 
  {
    id: '6',
    title: 'School grade 6',
    count: 181,
    image: require('./images/grade6.jpg'),
  }, 
  {
    id: '8',
    title: 'School grade 8',
    count: 900,
    image: require('./images/grade8.jpg'),
  }, 
  {
    id: '9',
    title: 'School grade 9',
    count: 635,
    image: require('./images/grade9.jpg'),
  }, 
  {
    id: '10',
    title: 'School grade 10',
    count: 160,
    image: require('./images/grade10.jpg'),
  }, 
  {
    id: 'custom',
    title: 'Custom',
    count: 10288,
    image: require('./images/custom.jpg'),
  }, 
];
